// A nav path only owns whole segments, so /competition-stages is not "on"
// /competition. A bare prefix lit both items in the sidebar.

export function isNavigationPathActive(pathname, path) {
  return Boolean(path) && (pathname === path || pathname.startsWith(`${path}/`));
}

export default isNavigationPathActive;
